import React from 'react';
import RecordCard from './RecordCard';
import { getAbsoluteUrl, getMediaUrl } from './creationRecordUtils';

export default function CreationRecordList({
  records,
  t,
  typeLabel,
  actions,
}) {
  return (
    <div className="records-grid">
      {records.map((record) => (
        <RecordCard
          key={record.id}
          record={record}
          t={t}
          typeLabel={typeLabel(record.type)}
          onDelete={actions.deleteRecord}
          onDownload={actions.downloadRecord}
          onPlayVideo={(item) => actions.setVideoModalUrl(getAbsoluteUrl(getMediaUrl(item)))}
          onShare={actions.openShare}
          onView={actions.viewRecord}
        />
      ))}
    </div>
  );
}
